import builder from '../builder';
import ReceiptDollar from '../../streamline-icons/light/receipt-dollar.svg';

export default builder('IconReceiptDollarLight', ReceiptDollar);
